import { render, staticRenderFns } from "./NormalSearchNav261.vue?vue&type=template&id=70bb4ae2&scoped=true&"
import script from "./NormalSearchNav261.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav261.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb4ae2",
  null
  
)

export default component.exports